import { AppTextField } from '../../components/AppTextField';
import { CRUDType } from '../../types/crud.type';
import EditFormComponent from '../common/EditFormComponent';
import { GroupRoutineType } from '../../types/grouproutines.type';
import { ValidationUtils } from '../../utils/validations.utils';
import { GroupRoutinesServices } from '../../services/grouproutines.service';
import { GroupRoutineExercisesField, GroupRoutineFieldProps } from './GroupRoutineExercisesField';

export function GroupRoutineEdit({ mode, phase }: CRUDType & { phase: GroupRoutineType['phase'] }) {
    return (
        <EditFormComponent<GroupRoutineType>
            title={phase == 'warmup' ? "Warm Up" : "Group Routine"}
            mode={mode}
            backPath={phase == 'warmup' ? "/warmups" : "/grouproutines"}
            service={{
                getById: GroupRoutinesServices.getById,
                add: phase == 'warmup' ? GroupRoutinesServices.addWarmUpRoutine : GroupRoutinesServices.addWorkoutRoutine,
                update: GroupRoutinesServices.update,
            }}
            formFields={[
                {
                    name: 'name',
                    component: AppTextField,
                    props: {
                        label: 'Name',
                        rules: {
                            required: 'Name is required'
                        },
                        columns: 8
                    }
                },
                {
                    name: 'exercises_duration',
                    component: AppTextField,
                    props: {
                        label: 'Exercises Duration (s)',
                        rules: {
                            validate: ValidationUtils.isInteger
                        },
                        columns: 2
                    }
                },
                {
                    name: 'exercises_count',
                    component: AppTextField,
                    props: {
                        label: 'Exercises Count',
                        rules: {
                            validate: ValidationUtils.isInteger
                        },
                        columns: 2
                    }
                },
                {
                    name: 'group_routine_exercises',
                    component: GroupRoutineExercisesField,
                    props: {
                        phase: phase
                    } as GroupRoutineFieldProps
                },

                //TODO button to generate exercises, list with the exercises?
            ]}
        />
    );

}